export default "__VITE_ASSET__DWooaqU6__"